<template>
  <div>
    <reset-password-form :type="'activate'" @activated="$router.replace('/login')" />
  </div>
</template>

<script>
import ResetPasswordForm from '@/components/pages/reset-password/ResetPasswordForm'
import store from '@/state/store.js'

export default {
  components: {
    ResetPasswordForm,
  },

  async beforeRouteEnter(to, from, next) {
    store.dispatch('auth/logOut')
    try {
      await store.dispatch('users/getActivationToken', to.params)
      return next()
    } catch (error) {
      return next(vm => {
        store.dispatch('app/notification', {
          type: 'error',
          group: 'auth',
          text: `user_activation_token`,
        })
        return next('/login')
      })
    }
  },
}
</script>
